jQuery(document).ready(function ($) {
  const dataTimer = $('.section-timer').attr('data-timer');

  if (dataTimer) {
    // Set the target date and time
    var targetDate = new Date(dataTimer).getTime();

    // Update the countdown every second
    var countdownTimer = setInterval(function () {
      // Get current time
      var now = new Date().getTime();

      // Calculate the remaining time
      var timeLeft = targetDate - now;

      // Time calculations for days, hours, minutes, and seconds
      var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      // Use padStart() to ensure two digits for hours, minutes, and seconds
      days = days.toString().padStart(2, '0');
      hours = hours.toString().padStart(2, '0');
      minutes = minutes.toString().padStart(2, '0');
      seconds = seconds.toString().padStart(2, '0');

      // Update the HTML content by setting the numbers and labels separately
      $('#days .number').html(days);
      $('#hours .number').html(hours);
      $('#minutes .number').html(minutes);
      $('#seconds .number').html(seconds);

      // If the countdown is finished, display a message
      if (timeLeft < 0) {
        clearInterval(countdownTimer);
        $('#countdown').html('<div class="h3 d-block mb-0 text-white w-100 text-center">Countdown Finished</div>');
      }
    }, 1000);
  }
});
